export default __webpack_public_path__ + "static/media/lowimpact.60bfa698.webp";